<template>
  <div>
    <b-card>
      <b-card-text>
        <p>For support, please email <a href="mailto:maria@hoi.my">maria@hoi.my</a></p>
      </b-card-text>
    </b-card>
    <b-card>
      <b-card-text>
        <p>
          Logo, favicon & Image banner design: <a
            :href="`https://api.whatsapp.com/send?phone=60124732709&text=I%20need%20to%20design%20a%20business%20Logo%2C%20FavIcon%20%26%20Banner%20for%20my%20${appName}.hoi.my%20website.`"
            target="_blank">012-4732709</a><br />
          <small>This is external service provider, service fee may apply.</small>
        </p>
      </b-card-text>
    </b-card>
    <!-- <b-card>
      <b-card-text>
        <p>
          Our automated renewal notification app (AI-Man) for Android is open for testing.
        </p>
        <p>
          Ai-Man v1.0: <a :href="`https://cloud.hoi.my/index.php/s/PnH34RxZQ2MqqGX`" target="_blank">Download</a>
        </p>
        <p>
          <ul>Automated Features:
            <li>Actively check vehicle expiry listed in FARA</li>
            <li>Send your unique renewal link through SMS to customers</li>
            <li>Randomized interval</li>
            <li>Run in background (upcoming)</li>
          </ul>
        </p>
        <p><small>** Please allow SMS access for Ai-Man SMS during installation. Normal SMS rate from your network provider may apply</small></p>
      </b-card-text>
    </b-card> -->
    <b-card>
      <b-card-text>
        <p>
          Windscreen cover auto removed from option for Car age 10 years and later<br />
          <small>Fixed underwriting refer case for unsupported extra cover</small>
        </p>
      </b-card-text>
    </b-card>
    <b-card>
      <b-card-text>
        <p>
          Bulk customer import fuction added.
        </p>
        <p>
          CSV template: <a :href="`https://www.hoi.my/downloads/fara-customer-import-template.csv`" target="_blank">Download</a>
        </p>
        <p>
        <ul>HOWTO:
          <li>Download CSV</li>
          <li>Update each field acordingly (either email or phone field is compulsary)</li>
          <li>Goto <a :href="`job/add`" target="_blank">https://fara.hoi.my/job/add</a></li>
          <li>Select your updated CSV file</li>
          <li>Click upload</li>
        </ul>
        </p>
        <p><small>** larger files will take longer time.</small></p>
      </b-card-text>
    </b-card>
    <b-card>
      <b-card-text>
        <p>
          E-Hailing (Yearly) added to additional cover<br />
          <small>Choosing e-hailing cover will automatically disable RoadTax renewal option</small>
        </p>
      </b-card-text>
    </b-card>
    <b-card>
      <b-card-text>
        <p>
          Notable partners website<br />
        <ul>
          <li>
            SRATA
            <ul>
              <li>
                Custom website: <a href="https://www.srata.com.my" target="_BLANK">https://www.srata.com.my</a>
              </li>
              <li>
                Automated WhatsApp response: <a href="https://api.whatsapp.com/send?phone=601162261601&text=%2Fquotation"
                  target="_blank">+601162261601</a>
              </li>
              <li>
                Automated WhatsApp renewal notification
              </li>
              <li>
                Automated Call decline with custom response
              </li>
            </ul>
          </li>
          <li>
            ROADTAXONTHEGO
            <ul>
              <li>
                Custom website: <a href="https://www.roadtaxonthego.com" target="_BLANK">https://www.roadtaxonthego.com</a>
              </li>
              <li>
                Automated WhatsApp response: <a href="https://api.whatsapp.com/send?phone=60182717515&text=%2Fquotation"
                  target="_blank">+60182717515</a>
              </li>
              <li>
                Automated WhatsApp renewal notification
              </li>
              <li>
                Automated Call decline with custom response
              </li>
            </ul>
          </li>
        </ul>
        <!-- <small>Choosing e-hailing cover will automatically disable RoadTax renewal option</small> -->
        </p>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue';
import store from '@/store'

export default {
  components: {
    BCard,
    BCardText,
  },
  data() {
    return {
      appName: store.state.verticalMenu.appName,
    }
  }
}
</script>

<style></style>
